import React, { Component } from "react";

// CSS
import "../../css/display-table.css";

// Utils
import { getFormattedAddressFromOrganization } from "../../utils/reviews/addresses";

class SearchReviews extends Component {
	render() {
		// Use either id or some other index name passed as prop
		const indexUsed = this.props.index ? this.props.index : "id";

		return (
			<React.Fragment>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Title</th>
								<th>Location</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr
									className="clickable"
									key={i}
									onClick={() =>
										this.props.history.push(
											this.props.basePath + "/" + item[indexUsed]
										)
									}
								>
									<td className="record-number">
										{i + this.props.startPosition + 1}
									</td>
									<td data-id="Organization">{item.title}</td>
									<td data-id="Location">
										{getFormattedAddressFromOrganization(item)}
									</td>
									<td className="edit-cell">
										<div className="edit_btn">Edit</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</React.Fragment>
		);
	}
}

SearchReviews.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default SearchReviews;



// WEBPACK FOOTER //
// ./src/components/search/SearchOrganizations.js